function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M72.6875 72.6992H53.4375V53.4492H72.6875V72.6992ZM58.25 67.8867H67.875V58.2617H58.25V67.8867Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.625 65.4805H19.75C15.9209 65.4805 12.2487 63.9594 9.54115 61.2518C6.83359 58.5443 5.3125 54.872 5.3125 51.043C5.3125 47.2139 6.83359 43.5417 9.54115 40.8341C12.2487 38.1266 15.9209 36.6055 19.75 36.6055H24.5625V41.418H19.75C17.1973 41.418 14.7491 42.432 12.9441 44.2371C11.1391 46.0421 10.125 48.4903 10.125 51.043C10.125 53.5957 11.1391 56.0438 12.9441 57.8489C14.7491 59.6539 17.1973 60.668 19.75 60.668H48.625V65.4805Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48.625 48.6367H29.375V29.3867H48.625V48.6367ZM34.1875 43.8242H43.8125V34.1992H34.1875V43.8242Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M58.25 41.418H53.4375V36.6055H58.25C60.8027 36.6055 63.2509 35.5914 65.0559 33.7864C66.8609 31.9813 67.875 29.5332 67.875 26.9805C67.875 24.4278 66.8609 21.9796 65.0559 20.1746C63.2509 18.3695 60.8027 17.3555 58.25 17.3555H29.375V12.543H58.25C62.0791 12.543 65.7513 14.0641 68.4589 16.7716C71.1664 19.4792 72.6875 23.1514 72.6875 26.9805C72.6875 30.8095 71.1664 34.4818 68.4589 37.1893C65.7513 39.8969 62.0791 41.418 58.25 41.418Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5625 24.5742H5.3125V5.32422H24.5625V24.5742ZM10.125 19.7617H19.75V10.1367H10.125V19.7617Z",
  fill: "white"
});

var SvgAutomation = function SvgAutomation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAutomation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/automation.e504c270.svg";
export { ForwardRef as ReactComponent };